export enum BulkActionAvailabilityCheckResult {
  /**
   * The bulk action does not need to be applied because the entry already has the wanted settings.
   */
  AlreadyAssigned = 'alreadyAssigned',

  /**
   * The bulk action can be applied.
   */
  Available = 'available',

  /**
   * The bulk action cannot be applied because the entry does not match the preconditions.
   */
  Unavailable = 'unavailable',
}
